import bulks from "./bulks";
import gifts from "./gifts";

export const exchanges = {
    bulks,
    gifts,
};
